import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { WritingHelper } from "@/components/ai/WritingHelper";
import { ImageStudio } from "@/components/ai/ImageStudio";
import { ReceiptDesign } from "@/components/ai/ReceiptDesign";

export default function AiStudio() {
  const { user } = useAuth();
  if (user?.role !== "owner") { return <Navigate to="/inbox" replace />; }
  return (
    <div className="p-4 sm:p-8 space-y-6" data-testid="ai-studio-page">
      <div>
        <p className="eyebrow text-gold/80">Company only</p>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold">AI Studio</h1>
        <p className="text-sm text-emerald-100/60 mt-1">Write messages and posts, and create flyers, visiting cards and advertisement posts.</p>
      </div>
      <div className="grid xl:grid-cols-2 gap-6">
        <WritingHelper />
        <ImageStudio />
        <ReceiptDesign />
      </div>
    </div>
  );
}
